// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SiteUnidades_RestaurarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/site_unidades/restaurar/{id}
 *
 * Restores a previously archived unit. No body required — the id travels in the URL.
 */
import { registerContract } from './validate'

export interface SiteUnidades_RestaurarInput {}

registerContract('SiteUnidades_RestaurarInput', {})
